/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from "relay-runtime";

import { FragmentRefs } from "relay-runtime";
export type AppContentQueryVariables = {
    includeFabHubJr?: boolean | null | undefined;
    skip?: boolean | null | undefined;
};
export type AppContentQueryResponse = {
    readonly viewer: {
        readonly " $fragmentRefs": FragmentRefs<"AppSideMenu_Viewer" | "FabHubJr_Viewer">;
    } | null;
};
export type AppContentQuery = {
    readonly response: AppContentQueryResponse;
    readonly variables: AppContentQueryVariables;
};



/*
query AppContentQuery(
  $includeFabHubJr: Boolean = false
  $skip: Boolean = false
) {
  viewer {
    ...AppSideMenu_Viewer @skip(if: $skip)
    ...FabHubJr_Viewer @include(if: $includeFabHubJr) @skip(if: $skip)
    id
  }
}

fragment AppSideMenu_Viewer on User {
  ...BadgeViewerCounts_Viewer
}

fragment BadgeViewerCounts_Viewer on User {
  countUnread: unreadChatsCount
  countUnassigned: chatActivityUnassignedCount
}

fragment FabHubJr_Viewer on User {
  countUnread: unreadChatsCount
  countUnassigned: chatActivityUnassignedCount
}
*/

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": false,
    "kind": "LocalArgument",
    "name": "includeFabHubJr"
  },
  {
    "defaultValue": false,
    "kind": "LocalArgument",
    "name": "skip"
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "AppContentQuery",
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "User",
        "kind": "LinkedField",
        "name": "viewer",
        "plural": false,
        "selections": [
          {
            "condition": "skip",
            "kind": "Condition",
            "passingValue": false,
            "selections": [
              {
                "args": null,
                "kind": "FragmentSpread",
                "name": "AppSideMenu_Viewer"
              },
              {
                "condition": "includeFabHubJr",
                "kind": "Condition",
                "passingValue": true,
                "selections": [
                  {
                    "args": null,
                    "kind": "FragmentSpread",
                    "name": "FabHubJr_Viewer"
                  }
                ]
              }
            ]
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "AppContentQuery",
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "User",
        "kind": "LinkedField",
        "name": "viewer",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "id",
            "storageKey": null
          },
          {
            "condition": "skip",
            "kind": "Condition",
            "passingValue": false,
            "selections": [
              {
                "alias": "countUnread",
                "args": null,
                "kind": "ScalarField",
                "name": "unreadChatsCount",
                "storageKey": null
              },
              {
                "alias": "countUnassigned",
                "args": null,
                "kind": "ScalarField",
                "name": "chatActivityUnassignedCount",
                "storageKey": null
              }
            ]
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "d0b1f618ae81de96c70e4b5317268f65",
    "id": null,
    "metadata": {},
    "name": "AppContentQuery",
    "operationKind": "query",
    "text": "query AppContentQuery(\n  $includeFabHubJr: Boolean = false\n  $skip: Boolean = false\n) {\n  viewer {\n    ...AppSideMenu_Viewer @skip(if: $skip)\n    ...FabHubJr_Viewer @include(if: $includeFabHubJr) @skip(if: $skip)\n    id\n  }\n}\n\nfragment AppSideMenu_Viewer on User {\n  ...BadgeViewerCounts_Viewer\n}\n\nfragment BadgeViewerCounts_Viewer on User {\n  countUnread: unreadChatsCount\n  countUnassigned: chatActivityUnassignedCount\n}\n\nfragment FabHubJr_Viewer on User {\n  countUnread: unreadChatsCount\n  countUnassigned: chatActivityUnassignedCount\n}\n"
  }
};
})();
(node as any).hash = '253724b9fbd7fabbeda3b8b410151830';
export default node;
